// const { message } = require("laravel-mix/src/Log");

class FindMyFood {
    constructor() {
        // Initialize variables
        this.feedingCalculationsData = window.QF.feedingCalculations;
        this.feedingJSON = this.feedingCalculationsData.weight_grouping;

        // Object to hold dog-related values
        this.dogValues = {
            dogId: '', // ID of the dog
            dogImage: '', // Image of the dog
            dogName: '', // Name of the dog
            dogBreed: '', // Breed of the dog
            dogAge: '', // Age of the dog
            dogFoodType: '', // Type of food preferred by the dog
            dogFavourites: '', // Flavours preferred by the dog
            dogWeight: '', // Weight of the dog
            dogDob: '', // Date of birth of the dog
            //dogWeightExpected: '', // Expected weight of the dog
            dogActive: '', // Activity level of the dog
            dogSiblings: '', // Whether the dog has siblings
            dogRescue: '', // Whether the dog is a rescue
            dogBio: '', // Biography of the dog
            dogInstagram: '', // Instagram handle of the dog
            dogTiktok: '', // TikTok handle of the dog
            dogGender: '', // Gender of the dog
            dogNeutered: '', // Neutered status of the dog
            tagArray: [], // Array to hold tags
            tagString: '', // String representation of tags
            wetGrams: 0, // Grams of wet food
            dryGrams: 0, // Grams of dry food
            wetTrays: '' // Number of wet food trays
        };

        // Initialize current step and base URL for collections
        this.currentStep = 0;
        this.baseUrlCollections = '/collections/your-recommendations/?sort_by=manual';
        this.weightFoodData = '';
        this.activityAgeData = '';
        this.activityLevel = '';
        this.today = new Date();
        this.aWeek = 7 * 24 * 60 * 60 * 1000;
        this.QFConnectorURL = "https://forthglade.qfconnector.com/api/"
        this.skipFormSubmissionOnLoad = false;

        // Initialize customer token
        this.customerToken = window.QF?.customer?.token || '';

        if (this.customerToken == null) {
            this.fetchCustomerToken();
        }

        // Initialize UI elements
        this.initUI();
        this.setupEventListeners();
        
        // Initialize drag scrolling for tabs
        if (window.QF && window.QF.initDragScroll) {
            window.QF.initDragScroll('.fmf-modal .tabs ul');
        }
        
        // Add scroll to end functionality for create new tab
        const createNewTab = document.querySelector('.fmf-modal [data-create-tab]');
        if (createNewTab) {
            createNewTab.addEventListener('click', () => {
                // Small delay to ensure the new tab is created first
                setTimeout(() => {
                    const tabsList = document.querySelector('.fmf-modal .tabs ul');
                    if (tabsList) {
                        tabsList.scrollTo({
                            left: tabsList.scrollWidth - tabsList.clientWidth,
                            behavior: 'smooth'
                        });
                    }
                }, 100);
            });
        }
    }



    initUI() {
        // Dog feeding preference radios
        this.dogFeedingPrefsRadios = document.querySelectorAll('input[name="dogs[0][dog_preferences]"]');
        this.dogActiveElements = document.querySelectorAll('[fmf-form-dog-active]');

        // Dog DOB
        this.dogBirthdayInput = document.getElementById('dog-dob');
        let maxDate = new Date().toISOString().split("T")[0];
        this.dogBirthdayInput.setAttribute('max', maxDate);
        this.dogBirthdayInput.setAttribute('required', 'required');

        // Step nav
        this.prevButton = document.querySelector('[fmf-prev-step]');
        this.nextButton = document.querySelector('[fmf-next-step]');
        this.startOver = document.querySelector('[fmf-start-over]');
        this.nextStep = document.querySelector('[fmf-next-step]');
        this.addNew = document.querySelector('[fmf-add-new]');
        // Step navigation buttons
        this.startOver.style.display = 'none';

        // Modal elements
        this.fmfModal = document.querySelector('.fmf-modal');
        this.fmfModalTab = document.querySelector('.fmf-modal .open-fmf');

        // Required inputs
        this.dogIdInput = document.querySelector('.fmf-modal input[name="dogs[0][id]"]');
        this.dogImage = document.querySelector('.fmf-modal [data-dog-image]');
        this.dogImageInput = document.querySelector('.fmf-modal input[name="dogs[0][dog_image]"]');
        this.dogNameInput = document.querySelector('.fmf-modal #dog-name');
        this.dogDobInput = document.querySelector('.fmf-modal #dog-dob');
        this.dogBreedInput = document.querySelector('.fmf-modal #dog-breed');
        this.dogAgeInput = document.querySelector('.fmf-modal #dog-age');
        this.dogFavouritesInput = document.querySelectorAll('.fmf-modal #dog-favourites');
        this.dogWeightInput = document.querySelector('.fmf-modal #dog-weight');
        //this.dogWeightExpectedInput = document.querySelector('.fmf-modal #dog-weight-expected');
        this.dogActiveInput = document.querySelectorAll('.fmf-modal input[name="dogs[0][dog_activity]"]');
        this.dogGenderInput = document.querySelectorAll('.fmf-modal input[name="dogs[0][dog_gender]"]');
        this.dogNeuteredInput = document.querySelectorAll('.fmf-modal input[name="dogs[0][dog_neutered]"]');
        this.dogRescueInput = document.querySelectorAll('.fmf-modal input[name="dogs[0][dog_rescue]"]');
        this.dogSiblingsInput = document.querySelector('.fmf-modal input[name="dogs[0][dog_siblings]"]');
        this.dogBioInput = document.querySelector('.fmf-modal textarea[name="dogs[0][dog_bio]"]');
        this.dogInstagramInput = document.querySelector('.fmf-modal input[name="dogs[0][dog_instagram]"]');
        this.dogTiktokInput = document.querySelector('.fmf-modal input[name="dogs[0][dog_tiktok]"]');
        this.formErrorsElement = document.querySelector('.fmf-form-errors');
        this.dogFavouritesCheckboxes = document.querySelectorAll('.fmf-modal input[name="dogs[0][dog_favourites][]"]');
        this.dogFavouritesElements = document.querySelectorAll('[fmf-form-dog-flavours]');

        // Steps
        this.fmfForm = document.querySelector('.fmf-form form');
        this.fieldsets = document.querySelectorAll('.fmf-form fieldset');
        this.dogNamesSteps = document.querySelectorAll('[fmf-form-dog-name]');
        this.stepsCounter = document.querySelector('.steps-counter span');
        this.progressBar = document.querySelector('.steps-progress-bar-progress');
        this.stepsTotal = document.querySelector('.steps-total');
        this.currentStepElement = document.querySelector('.current-step');

        this.passportImgSrc = this.fmfForm.dataset.passportImgSrc;

        // Tabs
        this.tabLinks = document.querySelectorAll('[data-create-tab]');

        // Other
        this.warning = document.querySelector('.topper-warning'),
        this.complementaryLink = document.querySelector('.complementary-link'),
        this.puppywarning = document.querySelector('.puppy-warning'),
        this.birthdayinfo = document.querySelector('.birthdayinfo'),
        this.contactlink = document.querySelector('.contact-link'),
        this.fieldsetWeight = document.querySelector('.fieldset[data-step="4"]')
        this.topperRadio = document.querySelector('#dog-feeding-topper')
        this.emailMessage = document.getElementById('email-message');
        this.emailInput = document.querySelector('.fmf-modal .account-tabs input[type="email"]');
        this.createAccountBtn = document.querySelector('.fmf-modal .account-tabs .register-tab-content .submitForm');

        // Set the ID of the dog
        this.dogValues.dogId = parseInt(this.dogIdInput.value);

        // Update progress bar
        this.updateProgressBar();

        this.tabLinks.forEach((tabLink) => {
            tabLink.addEventListener('click', (event) => {
                this.createNewTab(event);
            });
        });

        const userLoggedIn = localStorage.getItem('userLoggedIn') ? localStorage.getItem('userLoggedIn') : 'false';
        const passportSynced = localStorage.getItem('passportSynced') ? localStorage.getItem('passportSynced') : 'false';

        if (userLoggedIn == 'true' && passportSynced !== 'true') {
            // Push PassportLocal to the server
            const storedFormsArray = localStorage.getItem('passportLocal');
            let storedForms = [];
            if (storedFormsArray) {
                storedForms = JSON.parse(storedFormsArray);

                const formData = new FormData();
                storedForms.map((form, index) => {
                    Object.keys(form).forEach((key) => {
                        if (form[key] !== null) {
                            if (key === 'dog_favourites') {
                                // Split dog_favourites into individual values
                                const values = form[key].split('|');
                                values.forEach((value) => {
                                    formData.append(`dogs[${index}][${key}][]`, value);
                                });
                            } else if (key !== 'dog_image' && key !== 'customer_id' && key !== 'dog_passport_status') {
                                formData.append(`dogs[${index}][${key}]`, form[key]);
                            }
                        }
                    });

                    formData.append(`dogs[${index}][dog_passport_status]`, 'active');
                    formData.append(`dogs[${index}][customer_id]`, window.QF.customer.id);
                    // if (this.passportImgSrc !== '') {
                    //     formData.append(`dogs[${index}][dog_image]`, this.passportImgSrc);
                    // } else {
                    //     formData.delete(`dogs[${index}][dog_image]`);
                    // }
                });

                console.log('passport data pushed to server');

                // Send the form data to the endpoint
                fetch('https://forthglade.qfconnector.com/api/passport', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json'
                    },
                    body: formData
                })
                    .then(response => response.json())
                    .catch(error => console.error('Error:', error));

                localStorage.setItem('passportSynced', 'true');
            }
        } else {
            // Clear passport storage if user logged out
            if (window.QF.logged_in === false) {
                localStorage.setItem('passportSynced', 'false');
            }
        }
    }

    getElement(selector) {
        return document.querySelector(selector);
    }

    // Setup event listeners
    setupEventListeners() {
        // Event listener for dog feeding preference radios
        this.dogFeedingPrefsRadios.forEach((radio) => {
            radio.addEventListener('change', this.handleDogPreferencesChange.bind(this));
        });
        // Event listener for dog age input
        this.dogAgeInput.addEventListener('change', this.handleDogAgeChange.bind(this));
        // Event listener for dog birthday input
        this.dogBirthdayInput.addEventListener('change', this.handleDogBirthdayChange.bind(this));
        // Event listener for dog weight input
        this.dogWeightInput.addEventListener('input', this.handleDogWeightChange.bind(this));
        // Event listener for dog siblings change
        this.dogSiblingsInput.addEventListener('change', this.handleDogSiblingChange.bind(this));
        // Event listener for previous button click
        this.prevButton.addEventListener('click', this.handlePrevButtonClick.bind(this));
        // Event listener for next button click
        this.nextButton.addEventListener('click', this.handleNextButtonClick.bind(this));

        this.startOver.addEventListener('click', this.handleResetClick.bind(this));
        this.addNew.addEventListener('click', this.handleResetClick.bind(this));

        this.dogActiveInput.forEach((radio) => {
            radio.addEventListener('change', this.handleDogActivityRadios.bind(this));
        });

        this.dogGenderInput.forEach((radio) => {
            radio.addEventListener('change', this.handleDogGenderRadios.bind(this));
        });

        this.dogNeuteredInput.forEach((radio) => {
            radio.addEventListener('change', this.handleDogNeuteredRadios.bind(this));
        });

        this.dogRescueInput.forEach((radio) => {
            radio.addEventListener('change', this.handleDogRescueRadios.bind(this));
        });

        this.tabLinks.forEach((tabLink) => {
            tabLink.addEventListener('click', this.createNewTab.bind(this));
        });

        document.addEventListener('keydown', this.handleKeyDown.bind(this));

        if(this.emailInput) {
            this.emailInput.addEventListener('input', this.checkExistingEmail.bind(this));
            // this.emailInput.addEventListener('blur', this.checkExistingEmail.bind(this));
        }

        this.dogImageInput.addEventListener('change', (event) => {
            const dogImagePreview = document.querySelector('[data-dog-image]');
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    dogImagePreview.src = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        });

        this.dogValues.dogImage = document.querySelector('[data-dog-image]').src;

        this.initialStorageSetup();
        this.populateTabForms();
        this.bindTabs();
        this.bindAccountTabs();

        this.generateCollectionUrl();
        this.initKlaviyoForm();

        window.addEventListener('tab-created', () => {
            this.bindTabs();
        });
    }

    handleDogPreferencesChange(event) {
        const type = event.target.getAttribute('id');

        if (type === "dog-feeding-topper") {
            this.warning.classList.add('active');
            this.complementaryLink.classList.add('active');
            this.nextButton.classList.add('hide');
        } else {
            this.warning.classList.remove('active');
            this.complementaryLink.classList.remove('active');
            this.nextButton.classList.remove('hide');
        }
    }

    handleDogActivityRadios(event){
        const radioButton = event.target;
        if (radioButton.checked) {
            this.dogValues.dogActive = radioButton.value;

            this.dogActiveElements.forEach(element => {
                element.textContent = this.dogValues.dogActive;
            });

            let index = -1;
            this.activityLevel = event.target.id;

            if (this.dogAgeInput.value != '7+ senior' && this.dogAgeInput.value != '8 - 52 weeks puppy') {
                switch (event.target.id) {
                    case 'dog-active-sedentary':
                        index = 0;
                        break;
                    case 'dog-active-light':
                        index = 1;
                        break;
                    case 'dog-active-active':
                    case 'dog-active-very':
                        index = 2;
                        break;
                }
            } else {
                index = 0;
            }

            // Adjusted by dog weight
            const adjustedWeightIndex = this.dogValues.dogWeight - 1;
            this.activityAgeData = this.feedingJSON['activity-age'][index];

            if (this.activityAgeData['weight-food']) {
                this.weightFoodData = this.activityAgeData['weight-food'][adjustedWeightIndex];
            } else {
                console.log('No weight food data found');
            }
        }
    }

    handleDogGenderRadios(event){
        const radioButton = event.target;
        if (radioButton.checked) {
            this.dogValues.dogGender = radioButton.value;
        } else {
            this.dogValues.dogGender = 'no_answer';
        }
    }

    handleDogNeuteredRadios(event){
        const radioButton = event.target;
        if (radioButton.checked) {
            this.dogValues.dogNeutered = radioButton.value;
        } else {
            this.dogValues.dogNeutered = 'no_answer';
        }
    }

    handleDogRescueRadios(event){
        const radioButton = event.target;
        if (radioButton.checked) {
            this.dogValues.dogRescue = radioButton.value;
        } else {
            this.dogValues.dogRescue = 'no_answer';
        }
    }

    handleDogAgeChange() {
        if(this.dogAgeInput.value == '8 - 52 weeks puppy') {
            this.fieldsetWeight.classList.add('fieldset-puppy');
            this.dogBirthdayInput.setAttribute('required', 'required');
        } else {
            this.fieldsetWeight.classList.remove('fieldset-puppy');
            this.dogBirthdayInput.removeAttribute('required');
        }

        this.puppywarning.classList.remove('active');
        this.contactlink.classList.remove('active');
        this.nextButton.classList.remove('hide');
        this.birthdayinfo.style.display = 'block';
    }

    handleDogBirthdayChange() {

        this.dogBirthdayInput.addEventListener('input', (e) => {
            const inputValue = e.target.value;
            const todayStr = new Date().toISOString().split('T')[0];

            if (inputValue > todayStr) {
                e.target.classList.add('inError');
                e.target.setCustomValidity('Date cannot be in the future.');
            } else {
                e.target.classList.remove('inError');
                e.target.setCustomValidity('');
            }

            e.target.reportValidity();
        });

        let inputAge = new Date(document.getElementById('dog-dob').value);

        let diffTime = Math.abs(this.today - inputAge);
        let diffWeeks = Math.floor(diffTime / this.aWeek);

        if(diffWeeks > 52 && diffWeeks < 364) {
            //adult
            this.dogAgeInput.value = '1-7 years adult';
        } else if(diffWeeks > 364) {
            //senior
            this.dogAgeInput.value = '7+ senior';
        } else {
            //puppy
            this.dogAgeInput.value = '8 - 52 weeks puppy';
        }

        this.dogAgeInput.dispatchEvent(new Event('change'));

        if (diffWeeks < 8) {
            this.puppywarning.classList.add('active');
            this.contactlink.classList.add('active');
            this.nextButton.classList.add('hide');
        } else if (diffWeeks <= 52) {
            this.fieldsetWeight.classList.add('fieldset-puppy');
        } else {
            this.fieldsetWeight.classList.remove('fieldset-puppy');
            this.puppywarning.classList.remove('active');
            this.contactlink.classList.remove('active');
            this.nextButton.classList.remove('hide');
        }
    }

    handleDogSiblingChange() {
        this.dogSiblingsInput.addEventListener('input', (e) => {
            const value = parseFloat(e.target.value);

            if (value < 0) {
                e.target.classList.add('inError');
                e.target.setCustomValidity('Value cannot be negative.');
            } else {
                e.target.classList.remove('inError');
                e.target.setCustomValidity('');
            }

            e.target.reportValidity();
        });
    }

    handleDogWeightChange(event){
        event.target.value = event.target.value.replace(/[^0-9]/g, '');
    }

    updateButtonsAndCounter() {
        this.nextButton.style.display = this.currentStep === this.fieldsets.length - 1 ? 'none' : 'inline';
        this.startOver.style.display = this.currentStep === this.fieldsets.length - 1 ? 'inline' : 'none';
        this.stepsCounter.textContent = this.currentStep + 1;
    }

    showStep(stepIndex) {
        this.fieldsets.forEach((fieldset, index) => {
            fieldset.classList.toggle('active', index === stepIndex);
        });
        this.currentStep = stepIndex;
        this.updateProgressBar();
    }

    updateProgressBar() {
        this.progressBar.style.width = ((this.currentStep + 1) / this.fieldsets.length * 100) + '%';
    }

    updateUI() {
        this.updateButtonsAndCounter();
        this.updateProgressBar();
        this.stepsTotal.textContent = this.fieldsets.length;
        this.currentStepElement.textContent = this.currentStep + 1;
    }

    initialStorageSetup(){
        // Initial setup
        var storagedata = localStorage.getItem('FMF');
        if (!storagedata) return;

        var fmfdata = JSON.parse(storagedata);
        if (!fmfdata.dog_name) return;

        this.dogValues.dogId = this.dogIdInput.value = fmfdata.id;
        this.dogValues.dogName = this.dogNameInput.value = fmfdata.dog_name;
        this.dogImage.src = fmfdata.dog_image;
        this.dogValues.dogDob = this.dogDobInput.value = fmfdata.dog_dob;
        this.dogValues.dogBreed = this.dogBreedInput.value = fmfdata.dog_breed.replaceAll("_", " ");
        localStorage.setItem("breedsActive", true);
        this.dogValues.dogAge = this.dogAgeInput.value = fmfdata.dog_age;
        this.dogValues.dogFoodType = fmfdata.dog_preferences;
        this.dogValues.wetGrams = fmfdata.dog_wet_grams;
        this.dogValues.dryGrams = fmfdata.dog_dry_grams;
        this.dogValues.wetTrays = fmfdata.dog_wet_trays;
        this.dogValues.dogFavourites = fmfdata.dog_favourites;

        this.dogFavouritesCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                this.dogValues.dogFavourites.push(checkbox.value);
            }
        });

        this.dogGenderInput.forEach(radioButton => {
            if (radioButton.value === fmfdata.dog_gender) {
                radioButton.checked = true;
                this.dogValues.dogGender = fmfdata.dog_gender;
            }
        });

        this.dogNeuteredInput.forEach(radioButton => {
            if (radioButton.value === fmfdata.dog_neutered) {
                radioButton.checked = true;
                this.dogValues.dogNeutered = fmfdata.dog_neutered;
            }
        });

        this.dogRescueInput.forEach(radioButton => {
            if (radioButton.value === fmfdata.dog_rescue) {
                radioButton.checked = true;
                this.dogValues.dogRescue = fmfdata.dog_rescue;
            }
        });

        this.dogValues.dogSiblings = this.dogSiblingsInput.value = fmfdata.dog_siblings;
        this.dogValues.dogBio = this.dogBioInput.value = (fmfdata.dog_bio !== "no_answer") ? fmfdata.dog_bio : this.dogBioInput.value;
        this.dogValues.dogTiktok = this.dogTiktokInput.value = (fmfdata.dog_tiktok !== "no_answer") ? fmfdata.dog_tiktok : this.dogTiktokInput.value;
        this.dogValues.dogInstagram = this.dogInstagramInput.value = (fmfdata.dog_instagram !== "no_answer") ? fmfdata.dog_instagram : this.dogInstagramInput.value;

        this.dogValues.dogWeight = this.dogWeightInput.value = fmfdata.dog_weight_current;
        //this.dogValues.dogWeightExpected = this.dogWeightExpectedInput.value = fmfdata.dog_weight_expected;

        this.dogActiveInput.forEach(radioButton => {
            if (radioButton.value === fmfdata.dog_activity) {
                radioButton.checked = true;
                this.dogValues.dogActive = fmfdata.dog_activity;
            }
        });

        let selectedFavourites = '';
        const dogFavourites = fmfdata.dog_favourites;

        if (typeof dogFavourites === 'string') {
            selectedFavourites = fmfdata.dog_favourites.split("|").filter(checkbox => {
                const checkboxElement = document.getElementById(`dog-favourite-${checkbox}`);
                if (checkboxElement) {
                    checkboxElement.checked = true;
                    return true;
                }
                return false;
            });
        } else if (Array.isArray(dogFavourites)) {
            selectedFavourites = dogFavourites.filter(checkbox => {
                const checkboxElement = document.getElementById(`dog-favourite-${checkbox}`);
                if (checkboxElement) {
                    checkboxElement.checked = true;
                    return true;
                }
                return false;
            });
        }

        const selectedFavouritesString = selectedFavourites.length > 0
            ? selectedFavourites.length > 1
                ? `${selectedFavourites.slice(0, -1).join(', ')} and ${selectedFavourites[selectedFavourites.length - 1]}`
                : selectedFavourites[0]
            : 'everything';

        this.dogFavouritesElements.forEach(element => element.textContent = selectedFavouritesString);

        if (this.dogValues.dogFoodType) {
            const foodTypeElement = document.getElementById(this.dogValues.dogFoodType);
            if (foodTypeElement) foodTypeElement.checked = true;
        }

        const getDogActiveIndex = () => {
            if (this.dogValues.dogAge === '7+ senior' || this.dogValues.dogAge === '8 - 52 weeks puppy') {
                return 0;
            }
            switch (this.dogValues.dogActive) {
                case 'sedentary':
                    return 0;
                case 'lightly_active':
                    return 1;
                case 'active':
                    return 2;
            }
            return -1;
        };

        const index = getDogActiveIndex();
        const adjustedWeightIndex = this.dogValues.dogWeight - 1;
        this.activityAgeData = this.feedingJSON['activity-age'][index];

        if (this.activityAgeData?.['weight-food']) {
            this.weightFoodData = this.activityAgeData['weight-food'][adjustedWeightIndex];
        }

        let totalKcalRequirement = this.weightFoodData['kcal-required'];
        if (this.dogAgeInput.value == '8 - 52 weeks puppy') {
            let puppyDisclaimer = document.querySelectorAll('.puppy-disclaimer');
            if(puppyDisclaimer.length > 0){
                puppyDisclaimer[0].style.display = 'block';
            }

            const inputAge = new Date(this.dogDobInput.value);
            const diffWeeks = Math.floor((this.today - inputAge) / (7 * 24 * 60 * 60 * 1000));
            const lnWeeks = Math.log(diffWeeks);

            const weightArray = this.getWeightArray(this.dogValues.dogWeight);
            const percentFinalAdult = ((weightArray[0] * lnWeeks) - weightArray[1]) / 100;

            totalKcalRequirement = (254.1 - 135 * ((this.dogValues.dogWeight * percentFinalAdult) / this.dogValues.dogWeight)) * Math.pow((this.dogValues.dogWeight * percentFinalAdult), 0.75);
        }

        this.updateFoodOptionsDisplay(this.dogValues.dogFoodType, totalKcalRequirement);

        this.skipFormSubmissionOnLoad = true;
        this.showStep(7);
        this.nextButton.click();
        this.updateUI();
        this.skipFormSubmissionOnLoad = false;
    }

    openTab(evt, tabName) {

        // Declare all variables
        var i, tabcontent, tablinks;

        // Get all elements with class="tabcontent" and hide them
        tabcontent = document.getElementsByClassName("tab-content");
        for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].classList.remove("active");
        }

        // Get all elements with class="tablinks" and remove the class "active"
        tablinks = document.getElementsByClassName("tab-link");
        for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        // Show the current tab, and add an "active" class to the button that opened the tab
        document.getElementById(tabName).classList.add("active");
        evt.currentTarget.className += " active";

        const dogId = document.getElementById(tabName).dataset.dogId;
        const dogData = JSON.parse( localStorage.getItem('passport') )
        const activeData = dogData.find( obj => obj.id == dogId );

        this.generateCollectionUrl( activeData )
    }

    bindTabs() {
        // Get all elements with the attribute [data-change-tab]
        const tabs = document.querySelectorAll('[data-change-tab]');

        tabs.forEach((tabContainer) => {
          tabContainer.addEventListener('click', (event) => {
            event.preventDefault();
            // Check if the clicked element is a button
            if (event.target.classList.contains('tab-link')) {
              // Get the tab name from the data attribute of the clicked button
              var tabName = event.target.getAttribute('data-tab-name');

              // Call the openTab function with the event and tab name
              this.openTab(event, tabName);
            }
          });
        });
    }

    bindAccountTabs() {
        const registerTab = document.querySelector('.register-tab');
        const loginTab = document.querySelector('.login-tab');
        const registerTabContent = document.querySelector('.register-tab-content');
        const loginTabContent = document.querySelector('.login-tab-content');

        if (registerTab) {
            registerTab.addEventListener('click', (event) => {
                event.preventDefault();
                registerTab.querySelector('.account-tab-link').classList.add('active');
                loginTab.querySelector('.account-tab-link').classList.remove('active');
                registerTabContent.classList.remove('hidden');
                loginTabContent.classList.add('hidden');
            });
        }

        if (loginTab) {
            loginTab.addEventListener('click', (event) => {
                event.preventDefault();
                loginTab.querySelector('.account-tab-link').classList.add('active');
                registerTab.querySelector('.account-tab-link').classList.remove('active');
                loginTabContent.classList.remove('hidden');
                registerTabContent.classList.add('hidden');
            });
        }
    }

    createNewTab() {
        const tabsContainer = document.querySelector('.tabs'); // Or select the specific container if there are multiple
        if (!tabsContainer) {
          console.error('Tabs container not found');
          return;
        }

        const tabList = tabsContainer.querySelector('ul');
        const tabContents = tabsContainer.querySelectorAll('.tab-content');
        const newTabId = 'tab-' + (tabContents.length + 1);

        // Update input names and ids with the newTabId
        const newForm = document.querySelector('#fmf-tab-template').content.cloneNode(true);

        // Create new tab link element
        const newTabLink = document.createElement('li');
        newTabLink.innerHTML = `<button class="tab-link" data-change-tab="" data-tab-name="${newTabId}">
            <span fmf-form-dog-name data-dog="dog_name">Name</span>
          </button>`;

        // Create new tab content element
        const newTab = document.createElement('div');
        newTab.id = newTabId;
        newTab.classList.add('tab-content');
        newTab.appendChild(newForm);

        // Insert the new tab link and panel
        const lastTabLink = tabList.querySelector('li:last-child');
        tabList.insertBefore(newTabLink, lastTabLink ? lastTabLink.previousSibling : tabList.firstChild);
        tabsContainer.appendChild(newTab);

        // Dispatch a custom event to signal that a new tab has been created
        window.dispatchEvent(new CustomEvent('tab-created'));
    }

    populateTabForms() {
        const tabsContainer = document.querySelector('.tabs');

        const tabLinks = tabsContainer.querySelectorAll('li:not(:last-child):not(:first-child)');
        tabLinks.forEach((tabLink) => {
            tabLink.remove();
        });

        const tabContents = tabsContainer.querySelectorAll('.tab-content:not(:first-child)');
        tabContents.forEach((tabContent) => {
            tabContent.remove();
        });

        // Update the form data
        const passportData = JSON.parse(localStorage.getItem('passport')) || [];

        // Create a new array that excludes the last element
        const passportDataExcludingLast = passportData//.slice(0, -1);

        // Start loop from index 1 since the first form already exists
        passportDataExcludingLast.forEach((dogData, index) => {
            this.createNewTab();

            const tabIndex = index + 1; // To match the existing naming convention
            const tabContent = document.querySelector(`#tab-${tabIndex}`);

            const dogNames = tabContent.querySelectorAll('[fmf-form-dog-name]');
            const dogDob = tabContent.querySelector('[fmf-form-dog-age]');
            const dogFavourites = tabContent.querySelector('[fmf-form-dog-flavours]');
            const dogWeight = tabContent.querySelector('[fmf-form-dog-weight]');
            const dogActive = tabContent.querySelector('[fmf-form-dog-active]');
            const dogId = tabContent.querySelector('[fmf-form-dog-id]');
            const dogWetGrams = tabContent.querySelector('[fmf-form-wet-daily]');
            const dogDryGrams = tabContent.querySelector('[fmf-form-dry-daily]');
            const dogWetTrays = tabContent.querySelector('[fmf-tray-wet-daily]');

            if (dogId) {
                dogId.href += `?dogId=${dogData.id}`;
                tabContent.dataset.dogId = dogData.id;
            }
            dogWeight.textContent = dogData.dog_weight_current;
            dogActive.textContent = dogData.dog_activity.replace("_", " ");
            dogNames.forEach(element => element.textContent = dogData.dog_name);
            dogWetGrams.textContent = `${dogData.dog_wet_grams}g`;
            dogDryGrams.textContent = `${dogData.dog_dry_grams}g`;
            dogWetTrays.textContent = dogData.dog_wet_trays;

            dogFavourites.textContent = this.getSelectedFavourites(dogData.dog_favourites);

            const dogAgeValue = dogData.dog_age;

            let newDogAgeValue = '';
            if (dogAgeValue == '1-7 years adult') {
                newDogAgeValue = 'an adult dog';
            } else if (dogAgeValue == '7+ senior') {
                newDogAgeValue = 'a senior dog';
            } else if (dogAgeValue == '8 - 52 weeks puppy') {
                let today = new Date();
                let aWeek = 7 * 24 * 60 * 60 * 1000;
                let inputAge = new Date(dogData.dog_dob);

                let diffTime = Math.abs(today - inputAge);
                let diffWeeks = Math.floor(diffTime / aWeek);

                newDogAgeValue = 'a ' + diffWeeks + ' week old puppy';
            }

            dogDob.textContent = newDogAgeValue;

            const wetFoodSummary = tabContent.querySelector('[fmf-form-summary-wet-food]');
            const dryFoodSummary = tabContent.querySelector('[fmf-form-summary-dry-food]');
            const andElement = tabContent.querySelector('.and');

            const displayFoodSummary = (showWet, showDry, showAnd) => {
                wetFoodSummary.style.display = showWet ? 'block' : 'none';
                dryFoodSummary.style.display = showDry ? 'block' : 'none';
                andElement.style.display = showAnd ? 'flex' : 'none';
            };

            switch (dogData.dog_preferences) {
                case 'dog-feeding-wet-only':
                    displayFoodSummary(true, false, false);
                    break;
                case 'dog-feeding-dry-only':
                    displayFoodSummary(false, true, false);
                    break;

                case 'dog-feeding-mix':
                    displayFoodSummary(true, true, true);
                    break;

                default:
                    displayFoodSummary(true, true, true);
            }
        });

        const tabsContainerList = document.querySelector('.tabs ul');

        // scroll tabsContainerList to the bottom
        tabsContainerList.scrollLeft = tabsContainerList.scrollWidth;

        // Make the last tab the active tab
        const allTabLinks = document.querySelectorAll('[data-change-tab]');
        const lastTabLink = allTabLinks[allTabLinks.length - 1];
        if (lastTabLink) {
            lastTabLink.classList.add('active');
        }

        // Make the last content the active content
        const alltTabContents = document.querySelectorAll('.tab-content');
        const lastTabContent = alltTabContents[alltTabContents.length - 1];
        if (lastTabContent) {
            lastTabContent.classList.add('active');
        }

        // Update the tab names
        this.updateTabNames(passportDataExcludingLast);
    }

    handleCloseModal() {
        document.body.classList.remove('fixed');
        this.fmfModal.classList.remove('active');
        this.fmfModalTab.innerHTML = "Feeding Advice";
        window.dispatchEvent(new CustomEvent("find_my_food", { detail: this.dogValuesToObject() }));
    }

    handlePreviousStep(){
        if (this.warning.classList.contains('active')) {
            this.warning.classList.remove('active');
            this.complementaryLink.classList.remove('active');
            this.nextButton.classList.remove('hide');
            this.topperRadio.checked = false;
        }

        if (this.puppywarning.classList.contains('active')) {
            this.puppywarning.classList.remove('active');
            this.contactlink.classList.remove('active');
            this.nextButton.classList.remove('hide');
            this.dogBirthdayInput.value = null;
        }

        this.showStep(this.currentStep - 1);
        this.updateUI();

        if(this.emailMessage) {
            this.emailMessage.innerHTML = '';
        }
    }

    handlePrevButtonClick(){
        this.formErrorsElement.textContent = '';

        if(this.currentStep === 0){
            this.handleCloseModal();
        }

        if(this.currentStep > 0){
            this.handlePreviousStep();
        }
    }

    handleNextButtonClick(event){
        if (this.currentStep < this.fieldsets.length - 1) {
            // this.currentStepCheck(event);

            this.dogNamesValidate();
            this.dogBreed();
            this.dogAge();
            this.dogWeight();
            //this.dogWeightExpected();

            if(this.currentStepCheck(event)) {
                this.showStep(this.currentStep + 1);
            }

            this.updateUI();
        }

        // Only execute this code if we're not skipping form submission
        if (this.currentStep === 7 && !this.skipFormSubmissionOnLoad) {
            const fmfData = this.dogValuesToObject();

            // Retrieve the existing fmfdata from localStorage
            let passportData = JSON.parse(localStorage.getItem('passport')) || [];

            // Check if an object with the same dog_id already exists
            let existingObjectIndex = passportData.findIndex(obj => obj.id === fmfData.id);

            if (existingObjectIndex !== -1) {
                // Update the existing object with the new values
                Object.assign(passportData[existingObjectIndex], fmfData);
            } else {
                // Add the new fmfdata object to the array
                passportData.push(fmfData);
            }

            // Store the updated fmfdata array in localStorage
            localStorage.setItem('passport', JSON.stringify(passportData));
            // Store the passportSynced flag in localStorage if the user is not logged in
            if (window.QF.logged_in === false) {
                localStorage.setItem('passportLocal', JSON.stringify(passportData));
            }

            this.populateTabForms();
            this.bindTabs();
        }
    }

    handleKeyDown(event) {
        if (!this.fmfModal.classList.contains('active')) return;

        switch (event.keyCode) {
            // Enter key
            case 13:
            // Right arrow key
            // case 39:
            //     event.preventDefault();
            //     this.nextButton.click();
            //     break;
            // Left arrow key
            // case 37:
            //     event.preventDefault();
            //     this.prevButton.click();
            //     break;

            default:
                break;
        }
    }

    handleInputValidation(inputElements, errorMessage, validationCondition, event) {
        this.formErrorsElement.textContent = '';

        if (validationCondition) {
            if (Array.isArray(inputElements)) {
                inputElements.forEach(element => element.setAttribute('required', 'required'));
            } else {
                inputElements.setAttribute('required', 'required');
            }

            this.formErrorsElement.textContent = errorMessage;

            event.preventDefault();

            return true;
        } else {
            if (Array.isArray(inputElements)) {
                inputElements.forEach(element => element.removeAttribute('required'));
            } else {
                inputElements.removeAttribute('required');
            }
            this.formErrorsElement.textContent = '';
            return false;
        }
    }

    handleDogNameValidation(event) {
        const dogName = this.dogNameInput.value.trim();
        this.dogValues.dogName = dogName;

        window.log(this.dogValues.dogName);

        if(this.handleInputValidation(this.dogNameInput, 'Please fill out fields before progressing', dogName === '', event)) {
            return false;
        } else {
            return true;
        }
    }

    handleDogBreedValidation(event) {
        const breedsActive = localStorage.getItem("breedsActive");
        const dogBreed = this.dogBreedInput.value.trim();
        this.dogValues.dogBreed = dogBreed;

        if(this.handleInputValidation(this.dogBreedInput, 'Please select from the drop down list', dogBreed === '' || breedsActive == 'false', event)) {
            return false;
        } else {
            return true;
        }
    }

    handleDogAgeValidation(event){
        this.dogValues.dogAge = this.dogAgeInput;
        this.dogValues.dogDob = this.dogDobInput.value;

        if(this.handleInputValidation(this.dogDobInput, "Please enter your dog's date of birth", this.dogDobInput.value == '', event)) {
            return false;
        } else {
            return true;
        }
    }

    handleDogWeightValidation(event) {
        const weight = parseFloat(this.dogWeightInput.value.trim());
        this.dogValues.dogWeight = weight;

        // Check if weight input is empty
        if (isNaN(weight)) {
          if (this.handleInputValidation(
            this.dogWeightInput,
            "Please add your dog's weight to continue",
            true, // Always show the error message if weight is empty
            event
          )) {
            return false;
          } else {
            return true;
          }
        } else {
          // Check if weight exceeds maximum
          if (weight > 70) {
            this.dogWeightInput.value = 70; // Cap the weight at 70 kg
            this.dogValues.dogWeight = weight;
            if (this.handleInputValidation(
              this.dogWeightInput,
              'The maximum weight limit is 70kg',
              true, // Always show the error message for exceeding max weight
              event
            )) {
              return false;
            } else {
              return true;
            }
          } else {
            // Weight input is valid, remove any existing error message
            this.handleInputValidation(
              this.dogWeightInput,
              "", // Clear the error message
              false, // Do not show the error message
              event
            );
            return true;
          }
        }
    }

    handleDogFeedingPrefsValidation(event){
        const isAnyPrefSelected = Array.from(this.dogFeedingPrefsRadios).some(radio => radio.checked);
        let selectedPrefValue = null;

        this.dogFeedingPrefsRadios.forEach(radio => {
            if (radio.checked) {
                const label = document.querySelector(`label[for="${radio.id}"]`);
                selectedPrefValue = label ? label.textContent : '';
                this.dogValues.dogFoodType = radio.id;
            }
        });

        if (selectedPrefValue !== null) {
            this.dogValues.tagArray = [];
            switch (this.dogValues.dogFoodType) {
                case 'dog-feeding-wet-only':
                    this.dogValues.tagArray.push('type:wet_food');
                    break;
                case 'dog-feeding-dry-only':
                    this.dogValues.tagArray.push('type:dry_food');
                    break;
                case 'dog-feeding-mix':
                    this.dogValues.tagArray.push('type:wet_food', 'type:dry_food');
                    break;
                default:
                    break;
            }
        }

        this.formErrorsElement.textContent = '';

        let feedingInputArray = Array.from(this.dogFeedingPrefsRadios);

        if(this.handleInputValidation(
            feedingInputArray,
            'Please select a feeding preference',
            !isAnyPrefSelected,
            event
        )){
            return false;
        } else {
            return true;
        };
    }

    handleDogFavouritesValidation(event){
        let selectedFavourites = [];
        let selectedFavouritesString = '';

        // Check if at least one checkbox is selected
        // const isAnyCheckboxSelected = Array.from(this.dogFavouritesCheckboxes).some(checkbox => checkbox.checked);

        this.dogFavouritesCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                // Get the label associated with the selected checkbox
                const label = document.querySelector(`label[for="${checkbox.id}"]`);
                if (label) {
                    selectedFavourites.push(label.textContent);

                    if (checkbox.id != 'dog-favourite-no-preference') {
                        this.dogValues.tagArray.push(checkbox.id);
                    }
                }
            }
        });

        if (selectedFavourites.length === 8) {
            selectedFavouritesString = 'everything';
        } else if (selectedFavourites.length > 0) {
            const additionalFishTypes = ['herring', 'ocean fish', 'salmon', 'sardines', 'white fish'];

            // Check if 'Fish' is a selected value and add additional fish types
            if (selectedFavourites.includes('Fish')) {
                selectedFavourites.push(...additionalFishTypes);
            }

            this.dogValues.dogFavourites = selectedFavourites.join('|');

            const selectedFavouritesCopy = [...selectedFavourites];
            const lastElement = selectedFavouritesCopy.pop();

            if (selectedFavouritesCopy.length > 0) {
                selectedFavouritesString = selectedFavouritesCopy.join(', '); // Create a comma-separated string
                selectedFavouritesString += ' and ' + lastElement;
            } else {
                selectedFavouritesString = lastElement || 'everything'; // Handle case where array could be empty
            }

            this.dogFavouritesElements.forEach(element => {
                element.textContent = selectedFavouritesString;
            });
        } else {
            selectedFavouritesString = 'everything';
        }

        // let inputArray = Array.from(this.dogFavouritesCheckboxes);

        // if (this.handleInputValidation(
        //     inputArray,
        //     'Please select at least one favourite',
        //     !isAnyCheckboxSelected,
        //     event
        // )){
        //     return false;
        // } else {
        //     return true;
        // };

        return true;
    }

    handleDogActivityValidation(event){
        console.log('handleDogActivityValidation');
        const radioArray = Array.from(this.dogActiveInput);
        const isAnyRadioChecked = radioArray.some(radio => radio.checked);

        if (this.handleInputValidation(Array.from(this.dogActiveInput), "Please enter your dog's activity level", !isAnyRadioChecked, event)) {
            return false;
        } else {
            this.dogActiveInput.forEach(radioButton => {
                if (radioButton.checked) {
                    this.dogValues.dogActive = radioButton.value;
                    this.activityLevel = radioButton.id;
                }
            });

            let totalKcalRequirement = this.weightFoodData['kcal-required'];
            if (this.dogAgeInput.value == '8 - 52 weeks puppy') {
                let puppyDisclaimer = document.querySelectorAll('.puppy-disclaimer');
                if(puppyDisclaimer.length > 0){
                    puppyDisclaimer[0].style.display = 'block';
                }

                const inputAge = new Date(this.dogDobInput.value);
                const diffWeeks = Math.floor((this.today - inputAge) / (7 * 24 * 60 * 60 * 1000));
                const lnWeeks = Math.log(diffWeeks);

                const weightArray = this.getWeightArray(this.dogValues.dogWeight);
                const percentFinalAdult = ((weightArray[0] * lnWeeks) - weightArray[1]) / 100;

                totalKcalRequirement = (254.1 - 135 * ((this.dogValues.dogWeight * percentFinalAdult) / this.dogValues.dogWeight)) * Math.pow((this.dogValues.dogWeight * percentFinalAdult), 0.75);
            }

            if (this.dogAgeInput.value != '7+ senior' && this.dogAgeInput.value != '8 - 52 weeks puppy' && this.activityLevel == 'dog-active-sedentary') {
                this.activityAgeData = this.feedingJSON['activity-age'][1];
            }

            const { wetGrams, dryGrams, wetTrays } = this.updateFoodOptionsDisplay(this.dogValues.dogFoodType, totalKcalRequirement);

            this.dogValues.wetGrams = wetGrams;
            this.dogValues.dryGrams = dryGrams;
            this.dogValues.wetTrays = wetTrays;

            const fmfData = this.dogValuesToObject();

            window.dispatchEvent(new CustomEvent("find_my_food", { detail: fmfData }));

            localStorage.setItem('FMF', JSON.stringify(fmfData));

            if(window.QF.customer) {
                fetch('https://forthglade.qfconnector.com/api/find-my-food', {
                    method: 'POST',
                    headers: {
                        // 'Authorization': `Bearer ${this.customerToken}`,
                        'Content-type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify({ dogs: [fmfData] })
                })
                .then(response => response.json())
                // .then(data => console.log('Success:', data))
                .catch(error => console.error('Error:', error));
            }

            return true;
        };
    }

    handleLastStep(){
        console.log('Handle Last Step');
        this.dogValues.wetGrams = this.dogValues.wetGrams || 0;
        this.dogValues.dryGrams = this.dogValues.dryGrams || 0;
        this.dogValues.wetTrays = this.dogValues.wetTrays || '';
        this.dogValues.dogInstagram = this.dogInstagramInput.value;

        this.dogGenderInput.forEach(radioButton => {
            if (radioButton.checked) {
                this.dogValues.dogGender = radioButton.value;
            }
        });

        this.dogNeuteredInput.forEach(radioButton => {
            if (radioButton.checked) {
                this.dogValues.dogNeutered = radioButton.value;
            }
        });

        this.dogRescueInput.forEach(radioButton => {
            if (radioButton.checked) {
                this.dogValues.dogRescue = radioButton.value;
            }
        });

        this.dogValues.dogSiblings = this.dogSiblingsInput.value;
        this.dogValues.dogBio = this.dogBioInput.value;
        this.dogValues.dogTiktok = this.dogTiktokInput.value;
        this.dogValues.dogImage = document.querySelector('[data-dog-image]').src;

        const fmfData = this.dogValuesToObject();

        localStorage.setItem('FMF', JSON.stringify(fmfData));

        // Retrieve the existing fmfdata from localStorage
        let passportData = JSON.parse(localStorage.getItem('passport')) || [];

        // Check if an object with the same dog_id already exists
        let existingObjectIndex = passportData.findIndex(obj => obj.id === fmfData.id);

        if (existingObjectIndex !== -1) {
            // Update the existing object with the new values
            Object.assign(passportData[existingObjectIndex], fmfData);
        } else {
            // Add the new fmfdata object to the array
            passportData.push(fmfData);
        }

        // Store the updated fmfdata array in localStorage
        localStorage.setItem('passport', JSON.stringify(passportData));
        if (window.QF.logged_in === false) {
            localStorage.setItem('passportLocal', JSON.stringify(passportData));
        }

        window.dispatchEvent(new CustomEvent('pet_passport', { detail: fmfData }));

        const form = document.querySelector('.fmf-form form');
        const formData = new FormData(form);

        if(window.QF.customer) {
            formData.set('dogs[0][customer_id]', window.QF.customer.id);
        }

        if (fmfData['dogs[0][dog_siblings]'] === 'no_answer') {
            formData.set('dogs[0][dog_siblings]', 0);
        }

        ['dogs[0][dog_bio]', 'dogs[0][dog_instagram]', 'dogs[0][dog_tiktok]'].forEach(key => {
            if (fmfData[key] === 'no_answer') {
              formData.set(key, 'no_answer');
            }
        });

        // for (let [key, val] of formData.entries()) {
        //     console.log(key, val);
        // }

        const fileInput = document.querySelector('input[type="file"]');

        if(fileInput.files[0]) {
            formData.set('dogs[0][dog_image]', fileInput.files[0]);
        } else {
            formData.delete('dogs[0][dog_image]');
        }

        formData.set('dogs[0][dog_preferences]', this.dogValues.dogFoodType);
        formData.set('dogs[0][dog_activity]', this.dogValues.dogActive);

        if(window.QF.logged_in) {
            fetch('https://forthglade.qfconnector.com/api/passport', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                },
                body: formData,
            })
            .then(response => {
                if (!response.ok) {
                  throw { status: response.status, message: response.statusText };
                }
                return response.json();
              })
            .catch(error => {
                this.formErrorsElement.textContent = error.status === 422
                    ? 'Please upload a valid image file (jpeg, png, jpg, gif, svg) and the file size is no more than 2mb.'
                    : 'There was an error submitting your form. Please try again.';
            });
        }

        this.initKlaviyoForm();
    }

    currentStepCheck(event){
        switch(this.currentStep){
            case 0:
                return this.handleDogNameValidation(event);
            case 1:
                return this.handleDogBreedValidation(event);
            case 2:
                return this.handleDogAgeValidation(event);
            case 3:
                return this.handleDogWeightValidation(event);
            case 4:
                return this.handleDogFeedingPrefsValidation(event);
            case 5:
                return this.handleDogFavouritesValidation(event);
            case 6:
                return this.handleDogActivityValidation(event);
            case 7:
                // Only run handleLastStep if we're not skipping form submission
                if (!this.skipFormSubmissionOnLoad) {
                    this.handleLastStep();
                }
                return true;
        }
    }

    qfConnectorPost(path, formData, onSuccess, onError) {
        fetch(path, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.customerToken}`,
                },
                body: formData
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (typeof onSuccess === 'function') {
                    onSuccess(data);
                }
            })
            .catch(error => {
                if (typeof onError === 'function') {
                    onError(error);
                } else {
                    console.error('Error:', error);
                }
            });
    }

    getWeightArray(weight) {
        if (weight > 1 && weight <= 6) {
            return [36.92, 43.57]; // puppy1to6
        } else if (weight > 6 && weight <= 15) {
            return [36.86, 48.22]; // puppy7to15
        } else if (weight > 16 && weight <= 27) {
            return [39.88, 60.7]; // puppy16to27
        } else if (weight > 28 && weight <= 47) {
            return [36.96, 56.18]; // puppy28to47
        } else if (weight > 48) {
            return [36.61, 62.39]; // puppy48to70
        } else {
            return [36.92, 43.57]; // Default value (puppy1to6)
        }
    }

    // Method to show or hide food options based on the selected dog food type
    updateFoodOptionsDisplay(dogFoodTypeValue, totalKcalRequirement) {
        const wetFoodSummary = document.querySelector('[fmf-form-summary-wet-food]');
        const dryFoodSummary = document.querySelector('[fmf-form-summary-dry-food]');
        const andElement = document.querySelector('.and');
        const wetFoodGrams = document.querySelector('[fmf-form-wet-daily]');
        const dryFoodGrams = document.querySelector('[fmf-form-dry-daily]');
        const wetFoodTrays = document.querySelector('[fmf-tray-wet-daily]');

        const activityAgeDataWet = this.activityAgeData['wet-default'][0]['CEN ME(kcal/100g)'];
        const activityAgeDataDry = this.activityAgeData['dry-default'][0]['CEN ME(kcal/100g)'];

        let totalGramsWet = 0;
        let totalGramsDry = 0;
        let wetGrams = 0;
        let dryGrams = 0;
        let wetTrays = '';

        const calculateGrams = (kcalRequirement, kcalPer100g) => Math.round((kcalRequirement / kcalPer100g) * 100);

        const displayFoodSummary = (showWet, showDry, showAnd) => {
            wetFoodSummary.style.display = showWet ? 'block' : 'none';
            dryFoodSummary.style.display = showDry ? 'block' : 'none';
            andElement.style.display = showAnd ? 'flex' : 'none';
        };

        switch (dogFoodTypeValue) {
            case 'dog-feeding-wet-only':
                if(wetFoodSummary) {
                    displayFoodSummary(true, false, false);
                    wetFoodGrams.innerHTML = totalGramsWet + 'g';
                    wetFoodTrays.innerHTML = (totalGramsWet / 395).toFixed(2);
                }
                totalGramsWet = calculateGrams(totalKcalRequirement, activityAgeDataWet);
                wetGrams = totalGramsWet;
                wetTrays = (totalGramsWet / 395).toFixed(2);
                break;

            case 'dog-feeding-dry-only':
                if (dryFoodSummary) {
                    displayFoodSummary(false, true, false);
                    dryFoodGrams.innerHTML = totalGramsDry + 'g';
                }
                totalGramsDry = calculateGrams(totalKcalRequirement, activityAgeDataDry);
                dryGrams = totalGramsDry;
                break;

            case 'dog-feeding-mix':
                if (wetFoodSummary && dryFoodSummary) {
                    displayFoodSummary(true, true, true);
                    wetFoodGrams.innerHTML = totalGramsWet + 'g';
                    wetFoodTrays.innerHTML = (totalGramsWet / 395).toFixed(2);
                    dryFoodGrams.innerHTML = totalGramsDry + 'g';
                }
                totalGramsWet = Math.round(calculateGrams(totalKcalRequirement, activityAgeDataWet) / 2);
                totalGramsDry = Math.round(calculateGrams(totalKcalRequirement, activityAgeDataDry) / 2);

                dryGrams = totalGramsDry;
                wetGrams = totalGramsWet;
                wetTrays = (totalGramsWet / 395).toFixed(2);
                break;

            default:
                if(wetFoodSummary && dryFoodSummary && andElement) {
                    displayFoodSummary(true, true, true);
                }
        }

        return { wetGrams, dryGrams, wetTrays };
    }

    dogNamesValidate(){
        if(this.dogNameInput.value !== ''){
            this.dogValues.dogName = this.dogNameInput.value.trim();

            this.dogNamesSteps.forEach(element => {
                element.innerHTML = this.dogValues.dogName;
            });

            // this.firstTab.querySelector('[fmf-form-wet-daily]').textContent = this.dogValues.wetGrams + 'g';
            // this.firstTab.querySelector('[fmf-form-dry-daily]').textContent = this.dogValues.dryGrams + 'g';
            // this.firstTab.querySelector('[fmf-tray-wet-daily]').textContent = this.dogValues.wetTrays;
        }

    }

    dogBreed(){
        if (this.dogBreedInput.value !== '') {
            this.dogValues.dogBreed = this.dogBreedInput.value.trim();
        }
    }

    dogAge(){
        // Dog age
        if (this.dogAgeInput.value !== '') {
            this.dogValues.dogAge = this.dogAgeInput.value;

            if (this.dogValues.dogAge === '8 - 52 weeks puppy' && this.currentStep == 2) {
                //Only thing for puppy is to make sure that birthday becomes REQUIRED
            }

            //this.fieldsetWeight.classList.remove('fieldset-puppy');
            this.puppywarning.classList.remove('active');
            this.birthdayinfo.style.display = 'block';
            this.contactlink.classList.remove('active');
            this.nextButton.classList.remove('hide');

            // document.querySelectorAll('[fmf-form-dog-age]').forEach(element => {
            //     element.textContent = this.dogValues.dogAge;
            // });

            const summaryDogAgeElements = document.querySelectorAll('.summary-title [fmf-form-dog-age]');
            const newDogAgeValue = this.getNewDogAgeValue(this.dogValues.dogAge, this.dogDobInput.value);
            summaryDogAgeElements.forEach(element => {
                element.textContent = newDogAgeValue;
            });
        }
    }

    dogWeight(){
        // Dog weight
        if (this.dogWeightInput.value !== '') {
            this.dogValues.dogWeight = this.dogWeightInput.value.trim();
            // const dogWeightElements = document.querySelectorAll('[fmf-form-dog-weight]');
            // dogWeightElements.forEach(element => {
            //     element.textContent = this.dogValues.dogWeight;
            // });
        }
    }

    /* dogWeightExpected(){
        if (this.dogWeightExpectedInput.value !== '') {
            this.dogValues.dogWeightExpected = this.dogWeightExpectedInput.value.trim();
        }
    } */

    getNewDogAgeValue(dogAgeValue, dogDob) {
        if (dogAgeValue === '1-7 years adult') {
            return 'an adult dog';
        } else if (dogAgeValue === '7+ senior') {
            return 'a senior dog';
        } else if (dogAgeValue === '8 - 52 weeks puppy') {
            const inputAge = new Date(dogDob);

            const diffTime = Math.abs(this.today - inputAge);
            const diffWeeks = Math.floor(diffTime / this.aWeek);

            return `a ${diffWeeks} week old puppy`;
        }
        return '';
    }

    updateTabNames(passportDataExcludingLast) {
        const tabButtons = document.querySelectorAll('.tab-link span[data-dog="dog_name"]');
        passportDataExcludingLast.forEach((dogData, index) => {
            const tabButton = tabButtons[index];
            if (tabButton) {
                tabButton.textContent = dogData.dog_name;
            }
        });
    }

    getSelectedFavourites(favourites) {
        let favouritesArray = [];

        // Check if favourites is already an array or a string
        if (Array.isArray(favourites)) {
          favouritesArray = favourites; // Use directly if it's an array
        } else if (typeof favourites === 'string') {
          favouritesArray = favourites.split('|'); // Split if it's a string
        }

        const selectedFavourites = favouritesArray.filter(checkbox => {
          const checkboxElement = document.getElementById(`dog-favourite-${checkbox}`);
          if (checkboxElement) {
            return true;
          }
          return false;
        });

        if (selectedFavourites.length > 1) {
          return `${selectedFavourites.slice(0, -1).join(', ')} and ${selectedFavourites[selectedFavourites.length - 1]}`;
        } else if (selectedFavourites.length === 1) {
          return selectedFavourites[0];
        }
        return 'everything';
    }

    checkExistingEmail() {
        const email = this.emailInput.value;

        fetch('https://forthglade.qfconnector.com/api/email-exists', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                email: email,
            })
        })
        .then(response => response.json())
        .then(({data}) => {
            if (data.exists === true) {
                document.querySelector('.exists').innerHTML = 'Email already exists. Please login to continue.';
                this.createAccountBtn.disabled = true;
            } else {
                document.querySelector('.exists').innerHTML = '';
                this.createAccountBtn.disabled = false;
            }
        }).catch(error => console.error('Error:', error));
    }

    handleResetClick(event){
        event.preventDefault();
        this.resetFMF();
    }

    resetFMF(){
        localStorage.removeItem('FMF');
        this.initialStorageSetup();

        document.querySelector('.fieldset-summary').classList.remove('active');
        document.querySelector('.fieldset[data-step="1"]').classList.add('active');

        this.startOver.style.display = 'none';
        this.nextButton.style.display = 'inline';

        this.currentStep = 0;

        progressWidth = (this.currentStep + 1) / this.fieldsets.length * 100;
        this.progressBar.style.width = progressWidth + '%';
        this.currentStepElement.textContent = this.currentStep + 1;

        const fieldsetInputs = document.querySelectorAll('.fieldset input[type="text"], .fieldset input[type="number"], .fieldset input[type="date"], textarea');
        fieldsetInputs.forEach(input => {
            input.value = '';
        });

        this.dogAgeInput.selectedIndex = 0;

        // Clear checkboxes and radio buttons
        document.querySelectorAll('.fieldset input[type="checkbox"], .fieldset input[type="radio"]').forEach(input => {
            input.checked = false;
        });

        // Reset image
        this.dogImage.src = this.passportImgSrc;

        if (this.emailMessage) {
            this.emailMessage.innerHTML = '';
        }

        const updatedDogId = Date.now();
        this.dogValues.dogId = parseInt(updatedDogId);
        document.querySelector('[set-fmf-form-dog-id]').value = updatedDogId;
    }

    dogValuesToObject() {
        return {
            customer_id: window.QF.customer?.id || null,
            id: this.dogValues.dogId || null,
            dog_image: this.dogValues.dogImage || this.passportImgSrc,
            dog_name: this.dogValues.dogName || "no_answer",
            dog_dob: this.dogValues.dogDob || "no_answer",
            dog_wet_grams: this.dogValues.wetGrams || 0,
            dog_dry_grams: this.dogValues.dryGrams || 0,
            dog_wet_trays: this.dogValues.wetTrays || "no_answer",
            dog_breed: (this.dogValues.dogBreed && this.dogValues.dogBreed.trim() !== "") ? this.dogValues.dogBreed.replace(/\s/g, '_').toLowerCase() : "no_answer",
            dog_age: this.dogValues.dogAge || "",
            dog_weight_current: (this.dogValues.dogWeight && !isNaN(this.dogValues.dogWeight)) ? this.dogValues.dogWeight : "no_answer",
            //dog_weight_expected: (this.dogValues.dogWeightExpected && !isNaN(this.dogValues.dogWeightExpected)) ? this.dogValues.dogWeightExpected : "no_answer",
            dog_preferences: this.dogValues.dogFoodType || "no_answer",
            dog_favourites: (typeof this.dogValues.dogFavourites === 'string' && this.dogValues.dogFavourites.trim() !== "") ? this.dogValues.dogFavourites.toLowerCase() : "all recipes",
            dog_activity: (this.dogValues.dogActive && this.dogValues.dogActive.trim() !== "") ? this.dogValues.dogActive.trim().replace(/\s/g, '_').toLowerCase() : "no_answer",
            dog_gender: this.dogValues.dogGender || "no_answer",
            dog_neutered: this.dogValues.dogNeutered || "no_answer",
            dog_rescue: this.dogValues.dogRescue || "no_answer",
            dog_siblings: this.dogValues.dogSiblings || 0,
            dog_bio: this.dogValues.dogBio || "no_answer",
            dog_tiktok: this.dogValues.dogTiktok || "no_answer",
            dog_instagram: this.dogValues.dogInstagram || "no_answer",
            dog_passport_status: this.dogValues.dogPassportStatus || "no_answer",
        };
    }

    fetchCustomerToken() {
        fetch('https://forthglade.qfconnector.com/api/customer/auth', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            email: window.QF.customer.email,
            shopify_id: window.QF.customer.id,
          }),
          mode: 'no-cors'
        })
        .then(response => response.json())
        // .then(data => console.log('Success:', data))
        .catch(error => console.error('Error:', error));
    }

    generateCollectionUrl( dogData ) {
        const storagedata = localStorage.getItem('FMF');

        if (!dogData) {
            if (storagedata) {
                dogData = JSON.parse(storagedata);
            } else {
                dogData = {}; // Or handle the case when localStorage doesn't have the item
            }
        }

        if ( dogData ) {

            const baseUrlCollections = '/collections/your-recommendations/?sort_by=manual';
            this.RecommendedCollectionURL = baseUrlCollections;

            const dog_age = dogData.dog_age;
            const dog_favourites = dogData.dog_favourites;
            const dog_preferences = dogData.dog_preferences;

            // Age Filters
            if ( dog_age ) {
                if ( dog_age == '1-7 years adult' ) this.RecommendedCollectionURL += `&filter.p.m.filter.lifestage_filter=Adult`;
                else if ( dog_age == '7+ senior' ) this.RecommendedCollectionURL += `&filter.p.m.filter.lifestage_filter=Senior`;
                else this.RecommendedCollectionURL += `&filter.p.m.filter.lifestage_filter=Puppy`;
            }

            // Favourites / Flavours Filters
            if ( dog_favourites ) {
                const dog_favourites_arr = dog_favourites.split('|');

                dog_favourites_arr.forEach( favourite_food => {
                    this.RecommendedCollectionURL += `&filter.p.m.filter.flavour_ingredients_filter=${ favourite_food }`
                });
            }

            // Wet And Dry Filters
            if ( dog_preferences ) {
                if ( dog_preferences == 'dog-feeding-wet-only' ) this.RecommendedCollectionURL += `&filter.p.m.filter.product_type_filter=Wet+Food`;
                else if ( dog_preferences == 'dog-feeding-dry-only' ) this.RecommendedCollectionURL += `&filter.p.m.filter.product_type_filter=Dry+Food`;
                else this.RecommendedCollectionURL += `&filter.p.m.filter.product_type_filter=Wet+Food&filter.p.m.filter.product_type_filter=Dry+Food`;
            }

        }

    }

    initKlaviyoForm() {
        const emailFields = document.querySelectorAll('.fmf-klaviyo-form-wrapper .klaviyo-email-input');

        emailFields.forEach( emailField => {
            const sendEmail = emailField.closest('.email-recommendations').querySelector('button');
            emailField.addEventListener('keyup', function(e) {

                if(isValidEmail(emailField.value)) {
                    sendEmail.removeAttribute('disabled');
                } else {
                    sendEmail.setAttribute('disabled', true);
                }
            });

            const recommendationsSubmitButton = document.querySelector(".fmf-klaviyo-form-wrapper .email-recommendations button");

            document.addEventListener('click', (e) => {
                const storagedata = localStorage.getItem('FMF');
                const recommendationsURL = this.RecommendedCollectionURL;
                let html = document.querySelector('.fmf-klaviyo-form-wrapper .email-recommendations').innerHTML;

                if ( recommendationsURL && e.target.hasAttribute('fmf-send-email') ) {
                    const dogId = document.querySelector('.fmf-modal-form .fmf-form .tab-content.active').dataset.dogId;
                    const dogData = JSON.parse( localStorage.getItem('passport') )
                    const activeData = dogData.find( obj => obj.id == dogId );

                    e.preventDefault();
                    var fmfdata = activeData ? activeData : JSON.parse(storagedata);
                    var email = emailField.value;

                    klaviyo.push(['identify', {
                        '$email' : email,
                        'DogName' : fmfdata.dog_name,
                        'DogAge' : fmfdata.dog_age,
                        'DogBreed' : fmfdata.dog_breed,
                        'DogDOB' : fmfdata.dog_dob,
                        'DogActivity' : fmfdata.dog_activity,
                        'DogFavourites' : fmfdata.dog_favourites,
                        'DogFoodPref' : fmfdata.dog_preferences,
                        'DogWeight' : fmfdata.dog_weight_current,
                        'DogDryGrams' : fmfdata.dog_dry_grams,
                        'DogWetGrams' : fmfdata.dog_wet_grams,
                        'RecommendationURL': recommendationsURL,
                    }]);

                    klaviyo.push(['track', 'Feeding Guide Results', {
                        '$email': email,
                        'DogName': fmfdata.dog_name,
                        'DogAge': fmfdata.dog_age,
                        'DogBreed': fmfdata.dog_breed,
                        'DogDOB': fmfdata.dog_dob,
                        'DogActivity': fmfdata.dog_activity,
                        'DogFavourites': fmfdata.dog_favourites,
                        'DogFoodPref': fmfdata.dog_preferences,
                        'DogWeight': fmfdata.dog_weight_current,
                        'DogDryGrams': fmfdata.dog_dry_grams,
                        'DogWetGrams': fmfdata.dog_wet_grams,
                        'RecommendationURL': recommendationsURL,
                    }]);

                    const emailRecommendations = e.target.closest('.email-recommendations');
                    if (emailRecommendations) {
                        emailRecommendations.innerHTML = 'Thank you, your recommendations will be with you shortly.';
                        emailField.value = '';
                    } else {
                        console.error('Element with class .email-recommendations not found.');
                    }

                    /*
                    setTimeout(() => {
                        document.querySelector('.fmf-klaviyo-form-wrapper .email-recommendations').innerHTML = html;
                    }, 5000 ) ;
                    */
                }

            });
        })

        function isValidEmail(email) {
            const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return pattern.test(email);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const findMyFood = new FindMyFood();
});